import { CalendarDays } from 'lucide-react'

const NewThisMonthCallout = ({ newThisMonth }) => {
  const { headline, summary, sourceUrl } = newThisMonth

  return (
    <div className="rounded-2xl border border-[#ff914d]/30 bg-[#fff3ec] p-4 sm:p-5">
      <div className="mb-2 flex items-center gap-2 text-xs font-bold tracking-wide text-black uppercase">
        <CalendarDays className="size-4 shrink-0" aria-hidden="true" />
        <span>New this month</span>
      </div>
      <h2 className="text-foreground mb-1.5 text-base font-bold sm:text-lg">
        {headline}
      </h2>
      <p className="text-foreground/90 mb-2 text-sm leading-relaxed">
        {summary}
      </p>
      {sourceUrl && (
        <p className="text-sm">
          Read more{' '}
          <a
            href={sourceUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-[#ff914d] underline-offset-2 hover:underline"
          >
            here
          </a>
        </p>
      )}
    </div>
  )
}

export default NewThisMonthCallout
